import { render, staticRenderFns } from "./ChangeCallAnswerEffect.vue?vue&type=template&id=4ebaf20b&scoped=true&"
import script from "./ChangeCallAnswerEffect.vue?vue&type=script&lang=js&"
export * from "./ChangeCallAnswerEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebaf20b",
  null
  
)

export default component.exports